export const portalVersion = process.env.REACT_APP__VERSION || 'dev';
